import { chartPredictions } from "../charts/chartPredictions.js";

chartPredictions();
